var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-table",
    {
      attrs: {
        search: "",
        stripe: "",
        "max-items": "10",
        pagination: "",
        data: _vm.registros
      },
      scopedSlots: _vm._u([
        {
          key: "default",
          fn: function(ref) {
            var data = ref.data
            return _vm._l(data, function(tr, indextr) {
              return _c(
                "vs-tr",
                { key: indextr },
                [
                  _c("vs-td", [_vm._v(_vm._s(data[indextr].codigo))]),
                  _vm._v(" "),
                  _c("vs-td", [
                    _vm._v(_vm._s(data[indextr].descripcion_tipo_item))
                  ]),
                  _vm._v(" "),
                  _c("vs-td", [_vm._v(_vm._s(data[indextr].descripcion_tipo))]),
                  _vm._v(" "),
                  _c("vs-td", [
                    _vm._v(
                      _vm._s(
                        data[indextr].descripcion_categoria
                          ? data[indextr].descripcion_categoria
                          : "-"
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("vs-td", [_vm._v(_vm._s(data[indextr].nombre))]),
                  _vm._v(" "),
                  _c("vs-td", [_vm._v(_vm._s(data[indextr].descripcion))]),
                  _vm._v(" "),
                  _c("vs-td", [
                    _vm._v(
                      _vm._s(
                        data[indextr].descripcion_marca
                          ? data[indextr].descripcion_marca
                          : "-"
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("vs-td", [
                    _vm._v(
                      _vm._s(_vm.round3(data[indextr].cantidad_vendida, 2))
                    )
                  ])
                ],
                1
              )
            })
          }
        }
      ])
    },
    [
      _c("template", { slot: "header" }, [_c("h5", [_vm._v("REGISTROS:")])]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "thead" },
        [
          _c("vs-th", [_vm._v("Código")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Tipo")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Tipo Item")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Categoría")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Nombre")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Descripción")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Marca")]),
          _vm._v(" "),
          _c("vs-th", [_vm._v("Cant. Vendida")])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a95ae82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a95ae82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/TablaMasVendidos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7a95ae82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/reportes/TablaMasVendidos.vue
// module chunks = 0